// extracted by mini-css-extract-plugin
export default {"info":"NameChange_info__XF7Ky","title":"NameChange_title__-96PF","actions":"NameChange_actions__u7N5S","cancelBtn":"NameChange_cancelBtn__x716e"};